/**
 * Returns the singular or plural form of a word depending on the count
 *
 * Example:
 * ```ts
 * singularOrPlural(1, 'apple', 'apples') // => 'apple'
 * singularOrPlural(2, 'apple', 'apples') // => 'apples'
 * ```
 */
export const singularOrPlural = (
  count: number,
  singular: string,
  plural: string
): string => {
  return count === 1 ? singular : plural
}
